export const userActionTypes = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  SET_USER: "SET_USER",
  LOGOUT_USER: "LOGOUT_USER",
  SET_USER_NAME: "SET_USER_NAME",
}

export const spaceUsedType = {
  SPACEUSED_REQUEST: "SPACEUSED_REQUEST",
  SPACEUSED_SUCCESS: "SPACEUSED_SUCCESS",
  SPACEUSED_FAILURE: "SPACEUSED_FAILURE",
}

export const appTypes = {
  APPREDUCER_ALERT_REQUEST: "APPREDUCER_ALERT_REQUEST",
  APPREDUCER_ALERT_SUCCESS: "APPREDUCER_ALERT_SUCCESS",
  APPREDUCER_ALERT_FAILURE: "APPREDUCER_ALERT_FAILURE",
}

export const organizationTypes = {
  ORGANIZATION_NAME_REQUEST: "ORGANIZATION_NAME_REQUEST",
  ORGANIZATION_NAME_SUCCESS: "ORGANIZATION_NAME_SUCCESS",
  ORGANIZATION_CUIT_REQUEST: "ORGANIZATION_CUIT_REQUEST",
  ORGANIZATION_CUIT_SUCCESS: "ORGANIZATION_CUIT_SUCCESS",
  ORGANIZATION_TYPE_REQUEST: "ORGANIZATION_TYPE_REQUEST",
  ORGANIZATION_TYPE_SUCCESS: "ORGANIZATION_TYPE_SUCCESS",
  ORGANIZATION_TYPES_REQUEST: "ORGANIZATION_TYPES_REQUEST",
  ORGANIZATION_TYPES_SUCCESS: "ORGANIZATION_TYPES_SUCCESS",
  ORGANIZATION_TYPES_FAILURE: "ORGANIZATION_TYPES_FAILURE",
  ORGANIZATION_ADD_SEARCH_VALUE_CUIT: "ORGANIZATION_ADD_SEARCH_VALUE_CUIT",
  ORGANIZATION_DELETE_SEARCH_VALUE_CUIT:
    "ORGANIZATION_DELETE_SEARCH_VALUE_CUIT",
  ORGANIZATION_SET_SEARCH_NAME_VALUE: "ORGANIZATION_SET_SEARCH_NAME_VALUE",
  ORGANIZATION_DELETE_SEARCH_NAME_VALUE:
    "ORGANIZATION_DELETE_SEARCH_NAME_VALUE",
  ORGANIZATION_SET_SELECTED_TYPES_ORG: "ORGANIZATION_SET_SELECTED_TYPES_ORG",
  ORGANIZATION_ALL_REQUEST: "ORGANIZATION_ALL_REQUEST",
  ORGANIZATION_ALL_SUCCESS: "ORGANIZATION_ALL_SUCCESS",
  ORGANIZATION_ALL_FAILURE: "ORGANIZATION_ALL_FAILURE",
  ORGANIZATION_LEGALNAME_REQUEST: "ORGANIZATION_LEGALNAME_REQUEST",
  ORGANIZATION_LEGALNAME_SUCCESS: "ORGANIZATION_LEGALNAME_SUCCESS",
  ORGANIZATION_WITHID_REQUEST: "ORGANIZATION_WITHID_REQUEST",
  ORGANIZATION_WITHID_SUCCESS: "ORGANIZATION_WITHID_SUCCESS",
  ORGANIZATION_WITHID_FAILURE: "ORGANIZATION_WITHID_FAILURE",
  ORGANIZATION_USERS_REQUEST: "ORGANIZATION_USERS_REQUEST",
  ORGANIZATION_USERS_SUCCESS: "ORGANIZATION_USERS_SUCCESS",
  ORGANIZATION_USERS_FAILURE: "ORGANIZATION_USERS_FAILURE",
  ORGANIZATION_GET_USERS_SUSCRIBER_REQUEST:
    "ORGANIZATION_GET_USERS_SUSCRIBER_REQUEST",
  ORGANIZATION_GET_USERS_SUSCRIBER_SUCCESS:
    "ORGANIZATION_GET_USERS_SUSCRIBER_SUCCESS",
  ORGANIZATION_GET_USERS_SUSCRIBER_FAILURE:
    "ORGANIZATION_GET_USERS_SUSCRIBER_FAILURE",
  ORGANIZATION_GET_USER_DATA_REQUEST: "ORGANIZATION_GET_USER_DATA_REQUEST",
  ORGANIZATION_GET_USER_DATA_SUCCESS: "ORGANIZATION_GET_USER_DATA_SUCCESS",
  ORGANIZATION_SET_SUSCRIBER_REQUEST: "ORGANIZATION_SET_SUSCRIBER_REQUEST",
  ORGANIZATION_SET_SUSCRIBER_SUCCESS: "ORGANIZATION_SET_SUSCRIBER_SUCCESS",
  ORGANIZATION_SET_USER_OF_SUBSCRIBER_REQUEST:
    "ORGANIZATION_SET_USER_OF_SUBSCRIBER_REQUEST",
  ORGANIZATION_SET_USER_OF_SUBSCRIBER_SUCCESS:
    "ORGANIZATION_SET_USER_OF_SUBSCRIBER_SUCCESS",
}

export const eventanillaTypes = {
  EVENTANILLA_SUBSCRIBER_STATUS_REQUEST:
    "EVENTANILLA_SUBSCRIBER_STATUS_REQUEST",
  EVENTANILLA_SUBSCRIBER_STATUS_SUCCESS:
    "EVENTANILLA_SUBSCRIBER_STATUS_SUCCESS",
  EVENTANILLA_SUBSCRIBER_STATUS_FAILURE:
    "EVENTANILLA_SUBSCRIBER_STATUS_FAILURE",
  EVENTANILLA_SUBSCRIBER_DETAILS_REQUEST:
    "EVENTANILLA_SUBSCRIBER_DETAILS_REQUEST",
  EVENTANILLA_SUBSCRIBER_DETAILS_SUCCESS:
    "EVENTANILLA_SUBSCRIBER_DETAILS_SUCCESS",
  EVENTANILLA_SUBSCRIBER_DETAILS_FAILURE:
    "EVENTANILLA_SUBSCRIBER_DETAILS_FAILURE",
  EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS:
    "EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS",
  EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_ERROR:
    "EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_ERROR",
  EVENTANILLA_ADD_SEARCH_VALUE_CUIT: "EVENTANILLA_ADD_SEARCH_VALUE_CUIT",
  EVENTANILLA_DELETE_SEARCH_VALUE_CUIT: "EVENTANILLA_DELETE_SEARCH_VALUE_CUIT",
  EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES:
    "EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES",
  EVENTANILLA_CHANGE_SEARCH_STATUS: "EVENTANILLA_CHANGE_SEARCH_STATUS",
  EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME:
    "EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME",
  EVENTANILLA_DELETE_SEARCH_VALUE_STATUS:
    "EVENTANILLA_DELETE_SEARCH_VALUE_STATUS",
  EVENTANILLA_LOADING_ON: "EVENTANILLA_LOADING_ON",
  EVENTANILLA_LOADING_OFF: "EVENTANILLA_LOADING_OFF",
  EVENTANILLA_SUBSCRIBER_STATUS_CHANGE_ORDER:
    "EVENTANILLA_SUBSCRIBER_STATUS_CHANGE_ORDER",
  EVENTANILLA_DELEGATION_DATE_TIME_CHANGE_ORDER:
    "EVENTANILLA_DELEGATION_DATE_TIME_CHANGE_ORDER",
  EVENTANILLA_ADD_SEARCH_VALUE_CUIT_SUBSCRIPTION:
    "EVENTANILLA_ADD_SEARCH_VALUE_CUIT_SUBSCRIPTION",
  EVENTANILLA_DELETE_SEARCH_VALUE_CUIT_SUBCRIPTION:
    "EVENTANILLA_DELETE_SEARCH_VALUE_CUIT_SUBCRIPTION",
  EVENTANILLA_SUBSCRIBER_DETAILS_CHANGE_ORDER:
    "EVENTANILLA_SUBSCRIBER_DETAILS_CHANGE_ORDER",
  EVENTANILLA_CREATE_SUBSCRIPTION_SUCCESS:
    "EVENTANILLA_CREATE_SUBSCRIPTION_SUCCESS",
  EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS_ARCA:
    "EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS_ARCA",
  EVENTANILLA_UPDATE_SUBSCRIPTION_SUCCESS:
    "EVENTANILLA_UPDATE_SUBSCRIPTION_SUCCESS",
  EVENTANILLA_GET_SUBSCRIPTION_SUCCESS: "EVENTANILLA_GET_SUBSCRIPTION_SUCCESS",
  EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES_SUBCRIPTION:
    "EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES_SUBCRIPTION",
  EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME_SUBCRIPTION:
    "EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME_SUBCRIPTION",
  EVENTANILLA_SET_CLIENT_NAMES_SUBSCRIPTION:
    "EVENTANILLA_SET_CLIENT_NAMES_SUBSCRIPTION",
  EVENTANILLA_SET_DATE_FILTER: "EVENTANILLA_SET_DATE_FILTER",
  EVENTANILLA_CLEAR_DATE_FILTER: "EVENTANILLA_CLEAR_DATE_FILTER",
  EVENTANILLA_SET_USER_NAMES_SUBSCRIPTION:
    "EVENTANILLA_SET_USER_NAMES_SUBSCRIPTION",
  EVENTANILLA_CHANGE_SEARCH_USER_NAMES_SUBCRIPTION:
    "EVENTANILLA_CHANGE_SEARCH_USER_NAMES_SUBCRIPTION",
  EVENTANILLA_DELETE_SEARCH_VALUE_USER_NAME_SUBCRIPTION:
    "EVENTANILLA_DELETE_SEARCH_VALUE_USER_NAME_SUBCRIPTION",
  EVENTANILLA_SET_EV_STATUS: "EVENTANILLA_SET_EV_STATUS",
  EVENTANILLA_SET_SEARCH_EV_STATUS: "EVENTANILLA_SET_SEARCH_EV_STATUS",
  EVENTANILLA_CLEAR_SEARCH_EV_STATUS: "EVENTANILLA_CLEAR_SEARCH_EV_STATUS",
}
export const clientsTypes = {
  CLIENTS_GET_FIRMS_CUSTOMER: "CLIENTS_GET_FIRMS_CUSTOMER",
}

export const globalNotificationTypes = {
  SUBORG_GROUPS_REQUEST: "SUBORG_GROUPS_REQUEST",
  SUBORG_GROUPS_SUCCESS: "SUBORG_GROUPS_SUCCESS",
  SUBORG_GROUPS_FAILURE: "SUBORG_GROUPS_FAILURE",
  TYPES_REQUEST: "TYPES_REQUEST",
  TYPES_SUCCESS: "TYPES_SUCCESS",
  TYPES_FAILURE: "TYPES_FAILURE",
  NOTIFICATION_CONDITION_TYPES_REQUEST: "NOTIFICATION_CONDITION_TYPES_REQUEST",
  NOTIFICATION_CONDITION_TYPES_SUCCESS: "NOTIFICATION_CONDITION_TYPES_SUCCESS",
  NOTIFICATION_CONDITION_TYPES_FAILURE: "NOTIFICATION_CONDITION_TYPES_FAILURE",
}

export const adminAccessUserTypes = {
  ADMIN_ACCESS_RESET: "ADMIN_ACCESS_RESET",
  ADMIN_ACCESS_CLEAR_MESSAGES: "ADMIN_ACCESS_CLEAR_MESSAGES",

  ADMIN_ACCESS_SET_CUIT: "ADMIN_ACCESS_SET_CUIT",
  ADMIN_ACCESS_SET_ORG_FINISH_DATE: "ADMIN_ACCESS_SET_ORG_FINISH_DATE",
  ADMIN_ACCESS_SET_USER_FINISH_DATE: "ADMIN_ACCESS_SET_USER_FINISH_DATE",
  ADMIN_ACCESS_SET_SELECTED_ROLES: "ADMIN_ACCESS_SET_SELECTED_ROLES",
  ADMIN_ACCESS_SET_SELECTED_USER: "ADMIN_ACCESS_SET_SELECTED_USER",

  ADMIN_ACCESS_ROLES_REQUEST: "ADMIN_ACCESS_ROLES_REQUEST",
  ADMIN_ACCESS_ROLES_SUCCESS: "ADMIN_ACCESS_ROLES_SUCCESS",
  ADMIN_ACCESS_ROLES_FAILURE: "ADMIN_ACCESS_ROLES_FAILURE",

  ADMIN_ACCESS_VALIDATE_ORG_REQUEST: "ADMIN_ACCESS_VALIDATE_ORG_REQUEST",
  ADMIN_ACCESS_VALIDATE_ORG_SUCCESS: "ADMIN_ACCESS_VALIDATE_ORG_SUCCESS",
  ADMIN_ACCESS_VALIDATE_ORG_FAILURE: "ADMIN_ACCESS_VALIDATE_ORG_FAILURE",

  ADMIN_ACCESS_ORG_CONTEXT_REQUEST: "ADMIN_ACCESS_ORG_CONTEXT_REQUEST",
  ADMIN_ACCESS_ORG_CONTEXT_SUCCESS: "ADMIN_ACCESS_ORG_CONTEXT_SUCCESS",
  ADMIN_ACCESS_ORG_CONTEXT_FAILURE: "ADMIN_ACCESS_ORG_CONTEXT_FAILURE",

  ADMIN_ACCESS_ENABLE_ORG_REQUEST: "ADMIN_ACCESS_ENABLE_ORG_REQUEST",
  ADMIN_ACCESS_ENABLE_ORG_SUCCESS: "ADMIN_ACCESS_ENABLE_ORG_SUCCESS",
  ADMIN_ACCESS_ENABLE_ORG_FAILURE: "ADMIN_ACCESS_ENABLE_ORG_FAILURE",

  ADMIN_ACCESS_USER_CONTEXT_REQUEST: "ADMIN_ACCESS_USER_CONTEXT_REQUEST",
  ADMIN_ACCESS_USER_CONTEXT_SUCCESS: "ADMIN_ACCESS_USER_CONTEXT_SUCCESS",
  ADMIN_ACCESS_USER_CONTEXT_FAILURE: "ADMIN_ACCESS_USER_CONTEXT_FAILURE",

  ADMIN_ACCESS_ENABLE_USER_REQUEST: "ADMIN_ACCESS_ENABLE_USER_REQUEST",
  ADMIN_ACCESS_ENABLE_USER_SUCCESS: "ADMIN_ACCESS_ENABLE_USER_SUCCESS",
  ADMIN_ACCESS_ENABLE_USER_FAILURE: "ADMIN_ACCESS_ENABLE_USER_FAILURE",

  ADMIN_ACCESS_SUBMIT_ROLES_REQUEST: "ADMIN_ACCESS_SUBMIT_ROLES_REQUEST",
  ADMIN_ACCESS_SUBMIT_ROLES_SUCCESS: "ADMIN_ACCESS_SUBMIT_ROLES_SUCCESS",
  ADMIN_ACCESS_SUBMIT_ROLES_FAILURE: "ADMIN_ACCESS_SUBMIT_ROLES_FAILURE",

  ADMIN_ACCESS_REVOKE_ROLE_REQUEST: "ADMIN_ACCESS_REVOKE_ROLE_REQUEST",
  ADMIN_ACCESS_REVOKE_ROLE_SUCCESS: "ADMIN_ACCESS_REVOKE_ROLE_SUCCESS",
  ADMIN_ACCESS_REVOKE_ROLE_FAILURE: "ADMIN_ACCESS_REVOKE_ROLE_FAILURE",

  ADMIN_ACCESS_ENABLE_MODULE_REQUEST: "ADMIN_ACCESS_ENABLE_MODULE_REQUEST",
  ADMIN_ACCESS_ENABLE_MODULE_SUCCESS: "ADMIN_ACCESS_ENABLE_MODULE_SUCCESS",
  ADMIN_ACCESS_ENABLE_MODULE_FAILURE: "ADMIN_ACCESS_ENABLE_MODULE_FAILURE",

  ADMIN_ACCESS_ENABLE_PARAMS_REQUEST: "ADMIN_ACCESS_ENABLE_PARAMS_REQUEST",
  ADMIN_ACCESS_ENABLE_PARAMS_SUCCESS: "ADMIN_ACCESS_ENABLE_PARAMS_SUCCESS",
  ADMIN_ACCESS_ENABLE_PARAMS_FAILURE: "ADMIN_ACCESS_ENABLE_PARAMS_FAILURE",
  ADMIN_ACCESS_APP_CODE: "ADMIN_ACCESS_APP_CODE",

  ADMIN_ACCESS_APPLICATIONS_REQUEST: "ADMIN_ACCESS_APPLICATIONS_REQUEST",
  ADMIN_ACCESS_APPLICATIONS_SUCCESS: "ADMIN_ACCESS_APPLICATIONS_SUCCESS",
  ADMIN_ACCESS_APPLICATIONS_FAILURE: "ADMIN_ACCESS_APPLICATIONS_FAILURE",

}
